<div class="devices-container">
    @if (isLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <!-- Devices Grid -->
    @if (hasDevices()) {
    <div class="devices-grid">
        @for ( device of devices; track device.id) {
        <app-zone-item-device [device]="device">
        </app-zone-item-device>
        }
    </div>
    } @else {
    <div class="empty-state">
        <mat-icon>devices</mat-icon>
        <h3>No Devices Found</h3>
        @if (!isLoading) {
        <p>This device group does not contain any devices yet.</p>
        }
        @if (isLoading) {
        <p>Loading devices...</p>
        }
    </div>
    }
</div>